<template>
<div>
  <div id="searc-request-receipt">
    <div>
      <img alt='Company Image' src='../../../assets/scc-log.png' />
    </div>
    <div v-if="isPayByCheck && order.billingCustomer">
      <hr align="left"
      style="width:80%;height:2px;border-width:0;color:gray;background-color:lightgray">
      <p style='font-size:14px ;'><b>Application: </b>{{ order.billingCustomer.firstName }}
      {{ order.billingCustomer.lastName }}
      </p>
      <p style='font-size:14px ;'><b>Transaction Type: </b>{{ order.cardType }}</p>
      <p style='font-size:14px ;'>
      <b>Once payment has been received your application will be submitted for processing.</b></p>
      <p style='font-size:14px ;'><b>You can print off a copy of your invoice
      for payment in your eServices account under My Financial Transactions > Open Invoice.</b></p>
      <p style='color:chocolate;font-size:14px ;'><b>NOTE:</b></p>
      <p style='font-size:14px;'>
      1. If paying by Cheque, please make cheque payable to
      <span style="color:chocolate;"><b>Safety Codes Council</b></span></p>
      <p style='font-size:14px ;padding-left: 50px;'>500 10405 Jasper Avenue</p>
      <p style='font-size:14px ;padding-left: 50px;'>Edmonton, AB</p>
      <p style='font-size:14px ;padding-left: 50px;'>T5J 3N4</p>
      <p style='font-size:14px ;'>2. If paying by EFT, please contact
      <a href="mailto:accounting@safetycodes.ab.ca">accounting@safetycodes.ab.ca</a>
      for EFT information</p>
      <p style='font-size:14px ;'>3. Safety Codes Council <b>does not</b> accept e-transfers</p>
    </div>

    <div v-if="isPayByCredit && order.billingCustomer">
      <hr align="left"
      style="width:80%;height:2px;border-width:0;color:gray;background-color:lightgray">
      <p style='font-size:14px ;'><b>Application: </b>{{ order.billingCustomer.firstName }}
      {{ order.billingCustomer.lastName }}
      </p>
      <p style='font-size:14px ;'><b>Transaction Type: </b>{{ order.cardType }}</p>
      <p style='font-size:14px ;'>
      <b>Your application has been submitted for processing; however,
        payment is still required.</b></p>
      <p style='font-size:14px ;'><b>You can print off a copy of your invoice
      for payment in your eServices account under My Financial Transactions > Open Invoice.</b></p>
      <p style='color:chocolate;font-size:14px ;'><b>NOTE:</b></p>
      <p style='font-size:14px;'>
      1. If paying by Cheque, please make cheque payable to
      <span style="color:chocolate;"><b>Safety Codes Council</b></span></p>
      <p style='font-size:14px ;padding-left: 50px;'>500 10405 Jasper Avenue</p>
      <p style='font-size:14px ;padding-left: 50px;'>Edmonton, AB</p>
      <p style='font-size:14px ;padding-left: 50px;'>T5J 3N4</p>
      <p style='font-size:14px ;'>2. If paying by EFT, please contact
      <a href="mailto:accounting@safetycodes.ab.ca">accounting@safetycodes.ab.ca</a>
      for EFT information</p>
      <p style='font-size:14px ;'>3. Safety Codes Council <b>does not</b> accept e-transfers</p>
    </div>

    <div v-if="isPayByCreditCard && order.billingCustomer">
    <table class=MsoNormalTable border=0 cellspacing=3 cellpadding=0 width=80%
    style='width:80%'>
    <!-- <tr>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <h1><span style='font-family:"Arial",sans-serif'>SAFETY CODES COUNCIL</span></h1>
      </td>
    </tr> -->
    <tr style='height:7.5pt'>
      <td style='background:#5A5A5A;padding:3.10pt 3.10pt 3.10pt 3.10pt;height:
      7.5pt'></td>
    </tr>
    <tr>
      <td style='padding:.10pt .10pt .10pt .10pt'></td>
    </tr>
    <tr>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <h2><span style='font-family:"Arial",sans-serif;color:black'>
      {{ order.approvalCode }}</span></h2>
      </td>
    </tr>
    </table>
    <table class=MsoNormalTable border=0 cellspacing=3 cellpadding=0 style='width:80%'>
    <tr>
      <td colspan=2 style='background:#5A5A5A;padding:3.10pt 3.10pt 3.10pt 3.10pt'>
      <p class=MsoNormal><b><span style='font-size:10.0pt;font-family:"Arial",sans-serif;
      color:#E3E3E3'>PAYMENT DETAILS</span></b></p>
      </td>
    </tr>
    <tr>
      <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
      style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>TYPE</span></b></p>
      </td>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <span style='font-size:8.0pt;font-family:"Arial",sans-serif;
      color:black'>{{ order.transactionType }}</span>
      </td>
    </tr>
    <tr>
      <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
      style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>DATE</span></b></p>
      </td>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
      color:black'>{{ order.orderDate }}</span></p>
      </td>
    </tr>
    <tr>
      <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
      style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>ORDER ID</span></b></p>
      </td>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
      color:black'>{{ order.orderId }}</span></p>
      </td>
    </tr>
    <tr>
      <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
      style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>AMOUNT(CAD)</span></b></p>
      </td>
      <td style='padding:.10pt .10pt .10pt .10pt;'>
      <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
      color:black;' >
      <ejs-numerictextbox
          format = 'C2'
          :showSpinButton = 'spin'
          readonly = "true"
          v-model="order.amount"
          width="100px"
      />
        </span></p>
      </td>
    </tr>
    <tr>
      <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
      style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>CARDHOLDER</span></b></p>
      </td>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
      color:black'>{{ order.cardholderName }}</span></p>
      </td>
    </tr>
    <tr>
      <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
      style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>CARD NUM</span></b></p>
      </td>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
      color:black'>{{ order.maskedPan }}</span></p>
      </td>
    </tr>
    <tr>
      <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
      style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>ACCOUNT</span></b></p>
      </td>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
      color:black'>{{ order.cardType }}</span></p>
      </td>
    </tr>
    <tr>
      <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
      style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>REF NUM</span></b></p>
      </td>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
      color:black'>{{ order.referenceNum }}</span></p>
      </td>
    </tr>
    <tr>
      <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
      style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>AUTH CODE</span></b></p>
      </td>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
      color:black'>{{ order.authCode }}</span></p>
      </td>
    </tr>
    </table>
    <table class=MsoNormalTable border=0 cellspacing=3 cellpadding=0
    style='width:80%'>
    <tr>
      <td style='padding:.10pt .10pt .10pt .10pt'></td>
    </tr>
    </table>
    <table class=MsoNormalTable border=0 cellspacing=3 cellpadding=0
    style='width:80%'>
    <tr>
      <td colspan=2 style='background:#5A5A5A;padding:3.10pt 3.10pt 3.10pt 3.10pt'>
      <p class=MsoNormal><b><span style='font-size:10.0pt;font-family:"Arial",sans-serif;
      color:#E3E3E3'>CUSTOMER DETAILS</span></b></p>
      </td>
    </tr>
    <tr>
      <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
      style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>CUST ID</span></b></p>
      </td>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
      color:black'>{{ order.customerId }}</span></p>
      </td>
    </tr>
    <tr>
      <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
      style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>EMAIL</span></b></p>
      </td>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
      color:black'><a href="mailto:leo.xu@safetycodes.ab.ca">{{ order.emailAddress }}</a></span></p>
      </td>
    </tr>
    <tr>
      <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
      style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>NOTE</span></b></p>
      </td>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
      color:black'>{{ order.notes}}</span></p>
      </td>
    </tr>
    </table>
    <table class=MsoNormalTable border=0 cellspacing=3 cellpadding=0
    style='width:80%'>
    <tr>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <table class=MsoNormalTable border=0 cellspacing=3 cellpadding=0 width=298
      style='width:223.5pt'>
      <tr>
        <td colspan=2 style='background:#E3E3E3;padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal align=center style='text-align:center'><b><span
        style='font-size:8.0pt;font-family:"Arial",sans-serif;color:#131313'>BILLING
        DETAILS</span></b></p>
        </td>
      </tr>
      <tr>
        <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
        style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>FIRST
        NAME</span></b></p>
        </td>
        <td style='padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
        color:black'>{{ order.billingCustomer.firstName }}</span></p>
        </td>
      </tr>
      <tr>
        <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
        style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>LAST
        NAME</span></b></p>
        </td>
        <td style='padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
        color:black'>{{ order.billingCustomer.lastName }}</span></p>
        </td>
      </tr>
      <tr>
        <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
        style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>COMPANY</span></b></p>
        </td>
        <td style='padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
        color:black'>{{ order.billingCustomer.company }}</span></p>
        </td>
      </tr>
      <tr>
        <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
        style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>ADDRESS</span></b></p>
        </td>
        <td style='padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
        color:black'>{{ order.billingCustomer.address }}</span></p>
        </td>
      </tr>
      <tr>
        <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
        style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>CITY</span></b></p>
        </td>
        <td style='padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
        color:black'>{{ order.billingCustomer.city }}</span></p>
        </td>
      </tr>
      <tr>
        <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
        style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>PROV</span></b></p>
        </td>
        <td style='padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
        color:black'>{{ order.billingCustomer.province }}</span></p>
        </td>
      </tr>
      <tr>
        <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
        style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>COUNTRY</span></b></p>
        </td>
        <td style='padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
        color:black'>{{ order.billingCustomer.country }}</span></p>
        </td>
      </tr>
      <tr>
        <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
        style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>POST
        CODE</span></b></p>
        </td>
        <td style='padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
        color:black'>{{ order.billingCustomer.postCode }}</span></p>
        </td>
      </tr>
      <tr>
        <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
        style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>PHONE</span></b></p>
        </td>
        <td style='padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
        color:black'>{{ order.billingCustomer.phone }}</span></p>
        </td>
      </tr>
      <tr>
        <td width=150 nowrap style='width:112.5pt;padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal align=right style='margin-right:11.25pt;text-align:right'><b><span
        style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>FAX</span></b></p>
        </td>
        <td style='padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal><span style='font-size:8.0pt;font-family:"Arial",sans-serif;
        color:black'>{{ order.billingCustomer.fax }}</span></p>
        </td>
      </tr>
      </table>
      </td>
      <td style='padding:.10pt .10pt .10pt .10pt'></td>
    </tr>
    </table>
    <table class=MsoNormalTable border=0 cellspacing=3 cellpadding=0
    style='width:80%'>
    <tr style='height:22.5pt'>
      <td style='padding:.10pt .10pt .10pt .10pt;height:22.5pt'></td>
    </tr>
    <tr>
      <td style='padding:.10pt .10pt .10pt .10pt'>
      <p class=MsoNormal align=center style='text-align:center'>
      <span style='font-size:8.0pt;font-family:"Arial",sans-serif;color:black'>
      This receipt has been sent from an unmonitored email account.</span>
      </p>
      </td>
    </tr>
    <tr>
      <td style='padding:.10pt .10pt .10pt .10pt'>
        <p class=MsoNormal align=center style='text-align:left'>
          <span style='font-size:9.0pt;font-family:"Arial",sans-serif;color:black'>
          * Please make cheques payable to <b>Safety Codes Council</b>.</span>
        </p>
        <p class=MsoNormal align=center style='text-align:left'>
          <span style='font-size:9.0pt;font-family:"Arial",sans-serif;color:black'>
          * If you would like to pay by EFT, please contact
          <a href="mailto:accounting@safetycodes.ab.ca">accounting@safetycodes.ab.ca</a>
          for EFT information.</span>
        </p>
        <p class=MsoNormal align=center style='text-align:left'>
          <span style='font-size:9.0pt;font-family:"Arial",sans-serif;color:black'>
          * Please note: Safety Codes Council <b>does not</b> accept e-transfers.</span>
        </p>
      </td>
    </tr>
    </table>
    </div>
  </div>

  <div style="padding: 10px">
    <ejs-button
      cssClass="e-success"
      v-on:click.native="onContinueClick"
      data-test-search-request-receipt="bthp"
      style="padding: 5px"
      >
      Back to Home page
    </ejs-button>
    <ejs-button
      cssClass="e-info"
      v-on:click.native="onPrintClick"
      style="padding: 5px"
      >
      Print
    </ejs-button>
  </div>
</div>
</template>
<script>
import Vue from 'vue';
import {
  NumericTextBoxPlugin,
} from '@syncfusion/ej2-vue-inputs';
import { FETCH_ORDER_BY_ID } from '../store';

Vue.use(NumericTextBoxPlugin);

export default {
  name: 'Receipt',
  components: {
  },
  data() {
    return {
      order: {},
      spin: false,
    };
  },
  created() {
    if (this.$route.params.id !== null
    && this.$route.params.id !== undefined) {
      this.getOrderById(this.$route.params.id);
    }
  },
  mounted() {
  },
  computed: {
    isPayByCreditCard() {
      return this.order.cardType !== 'Credit' && this.order.cardType !== 'Cheque' && this.order.cardType !== 'EFT';
    },
    isPayByCredit() {
      return this.order.cardType === 'Credit';
    },
    isPayByCheck() {
      return this.order.cardType === 'Cheque' || this.order.cardType === 'EFT';
    },
  },
  methods: {
    onContinueClick() {
      this.$router.push('/');
    },
    onPrintClick() {
      const divContents = document.getElementById("searc-request-receipt").innerHTML;
      const printWindow = window.open('', '', 'height=900, width=800');
      printWindow.document.write('<html>');
      printWindow.document.write('<body >');
      printWindow.document.write(divContents);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
      setTimeout(() => { printWindow.close(); }, 100);
    },
    async getOrderById(requestId) {
      try {
        await this.$store.dispatch(FETCH_ORDER_BY_ID, requestId).then((resp) => {
          this.order = resp;
        });
        // .catch((error) => console.error(`get-order_err:${error.Status}`));
      } catch (error) {
        this.$parent.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content: error.message,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        if (this.$parent.$parent.$parent.notificationToasts.length > 0) {
          this.$parent.$parent.$parent.$refs.notifierRef.show();
        }
      }
    },
  },
};
</script>
